export default "__VITE_ASSET__aa97512b__"